function requiredIf(type, condition) {
    if (typeof type !== 'function') {
        throw new Error('Invalid prop \'type\' supplied to custom \'requiredIf\' validator.');
    }

    if (typeof condition !== 'function') {
        throw new Error('Invalid prop \'condition\' supplied to custom \'requiredIf\' validator.');
    }

    return function(props, propName, componentName) {
        const validation = condition(props)
            ? type.isRequired
            : type;

        return validation.apply(this, arguments);
    };
}

export default {
    requiredIf
};
